/*
 * @Author: tianzhitong laotianwy@163.com
 * @Date: 2023-08-30 10:09:32
 * @LastEditors: yusha
 * @LastEditTime: 2024-03-05 15:20:05
 * @FilePath: \ckb-smc-client-fed\src\model\User.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { atom } from 'jotai';
import { Site } from '@/const/enum';
import { CustomerRes } from '@/common/Layout/Header';
import { CACHE_STATION_NAME } from '@/const/staticURL';
import { lang } from '@/i18n/i18n';

const getDefaultStation = () => {
    if (lang === undefined) {
        return (
            (window.localStorage.getItem(CACHE_STATION_NAME) as Site) || Site.JP
        );
    }
    if (lang === 'ja') {
        return Site.JP;
    } else if (lang === 'ko') {
        return Site.KR;
    } else if (lang === 'en') {
        return Site.UK;
    }
};
/** 站点 */
const stationCode = atom<Site>(getDefaultStation() ?? Site.JP);
/** 用户信息 */
const atomRequestUserDetail = atom<CustomerRes>({});
/** 汇率 */
const exchangeRate = atom<number>(0);

export default { stationCode, atomRequestUserDetail, exchangeRate };
